import React from "react";
import SettingsSection from "../SettingsSection";

export default function ColorPanelsSection({ colorPanels, setColorPanels }) {
  const update = (patch) => setColorPanels((prev) => ({ ...prev, ...patch }));

  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Defaults used by <code>/setup-colors</code> when you don’t pass{" "}
        <code>message</code> / <code>title</code> in Discord. Placeholders:{" "}
        <code>{"{roles}"}</code>, <code>{"{family}"}</code>,{" "}
        <code>{"{emoji}"}</code>. Leave blank for the built-in box style. After
        saving, run <code>/setup-colors</code> with <code>repost: True</code>{" "}
        (delete old color panel messages first) to apply a new look.
      </p>

      <label className="input-label">PANEL TITLE TEMPLATE</label>
      <input
        type="text"
        className="settings-input"
        value={colorPanels.panelTitle || ""}
        onChange={(e) => update({ panelTitle: e.target.value })}
        placeholder="e.g. {emoji} {family} Colors"
        maxLength={256}
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        PANEL MESSAGE TEMPLATE
      </label>
      <textarea
        className="settings-input"
        rows={6}
        value={colorPanels.panelMessage || ""}
        onChange={(e) => update({ panelMessage: e.target.value })}
        placeholder={
          "Pick a {family} shade:\n╭✦ ⎯ ♡\n┊ {roles}\n╰✦ ⎯ ♡"
        }
        maxLength={2000}
      />
    </SettingsSection>
  );
}
